<div
  class="relative overflow-x-auto bg-surface-elevated border-b border-border-strong text-text-muted antialiased scrollbar-none">
  <ul class="relative flex min-w-max items-center gap-1.5 px-3 sm:px-6 lg:px-8">

    <span
      class="pointer-events-none absolute bottom-0 h-[3px] rounded-t-full bg-gradient-to-r from-primary to-orange-400 transition-all duration-300 ease-out shadow-[0_-2px_10px_rgba(228,87,5,0.6)]"
      [style.width.px]="activeTabWidth" [style.left.px]="activeTabLeft">
    </span>

    <li class="shrink-0" *ngFor="let tab of tabs; let i = index" #tabRef>
      <button *ngIf="tab.id !== 'create-unit'" (click)="onTabClick(tab.id)"
        class="relative inline-flex items-center gap-2 whitespace-nowrap rounded-t-xl px-4 py-3.5 text-xs font-bold tracking-wide uppercase transition-all duration-200 hover:text-text-primary sm:px-5 sm:py-4.5 lg:px-6 lg:py-5 group cursor-pointer"
        [class.text-text-primary]="isActiveTab(tab.id)" >

        <span class="w-1.5 h-1.5 rounded-full bg-primary scale-0 transition-transform duration-200 group-hover:scale-100 shadow-glow"
          [class.scale-100]="isActiveTab(tab.id)">
        </span>

        <span class="transition-colors duration-200">
          {{ tab.title | translate }}
        </span>
      </button>
    </li>

  </ul>
</div>